import React from 'react'
import classNames from "classnames";

import { connect } from 'react-redux';

import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";

import Delete from "@material-ui/icons/Delete";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown, faCheck, faExclamationTriangle, faExclamationCircle, faComment, faReply, faCertificate, faQuestion } from '@fortawesome/pro-solid-svg-icons';

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import * as allStyles from "assets/jss/material-dashboard-pro-react.jsx";
import Api from '../../api/Api.js';
import NotificationEndpoints from '../../api/NotificationEndpoints';
import { store } from '../../redux/store';
import { SET_NOTIFICATIONS } from '../../redux/types';
import Empty from '../Empty/Empty';
import ScrollContainer from '../Scroll/ScrollContainer';
import { Link } from 'react-router-dom';
import { IconButton } from '@material-ui/core';

const determineNotificationDetail = (type) => {
    var fa, color;

    switch (type) {
        case 'activate':
            fa = faThumbsUp;
            color = 'success';
            break;
        case 'deactivate':
            fa = faThumbsDown;
            color = 'danger';
            break;
        case 'check':
            fa = faCheck;
            color = 'success';
            break;
        case 'warning':
            fa = faExclamationTriangle;
            color = 'warning';
            break;
        case 'danger':
            fa = faExclamationCircle;
            color = 'danger';
            break;
        case 'comment':
            fa = faComment;
            color = 'info';
            break;
        case 'reply':
            fa = faReply;
            color = 'info';
            break;
        case 'reserve':
            fa = faCertificate;
            color = 'info';
            break;
        default:
            console.error('Unknown Notification Type');
            fa = faQuestion;
            color = '#D81B60';
            break;
    }

    return {
        fa, 
        color
    }
}

class NotificationsList extends React.Component {

    notificationClicked(notification) {
        this.props.close();
    }

    removeClicked(notification_id) {
        Api.get(NotificationEndpoints.remove, { id: notification_id }).then(({ data }) => {
            store.dispatch({ type: SET_NOTIFICATIONS, payload: this.props.notifications.filter(x => x.id !== notification_id) });
        }).catch((e) => {
            console.error(e);
        })
        //this.props.close();
    }

    clearClicked = () => {
        Api.get(NotificationEndpoints.clear).then(({ data }) => {
            store.dispatch({ type: SET_NOTIFICATIONS, payload: [] });
        }).catch((e) => {
            console.error(e);
        })
    }

    render() {

        const { classes } = this.props;

        const dropdownItem = classNames(
            classes.dropdownItem,
            classes.primaryHover
        );

        const clearAll = classNames(
            classes.dropdownItem,
            classes.primaryHover,
            classes.dropdownItemCentered
        );

        return (
            <MenuList role="menu">
                {
                    this.props.notifications && this.props.notifications.length > 0 ?
                        [
                            <ScrollContainer key="notifications_list" style={{ maxHeight: 400 }}>
                                {
                                    this.props.notifications.map(
                                        notification =>
                                            <div
                                                key={notification.id.toString()}
                                                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingRight: 4 }}
                                            >
                                                <MenuItem
                                                    onClick={() => this.notificationClicked(notification)}
                                                    className={dropdownItem}
                                                    component={Link}
                                                    to={notification.url.replace(/http(s)?:\/{2}(localhost:[0-9]{5}|reportmailman[\-qa]?.cellfind.co.za|reportmailman[web]?[react]?.conveyor.cloud)/gi, "")}
                                                    style={{ paddingRight: 0, flex: 1 }}
                                                >
                                                    <div style={{ display: 'flex', flex: 1, flexGrow: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', textAlign: 'left' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingTop: 5, paddingBottom: 5 }}>
                                                            <span>
                                                                <FontAwesomeIcon icon={determineNotificationDetail(notification.type).fa} color={allStyles[determineNotificationDetail(notification.type).color + "Color"]} />
                                                            </span>
                                                            <span style={{ fontWeight: 'bold', flex: 1, paddingLeft: 10 }}>{notification.title}</span>
                                                        </div>
                                                        {
                                                            notification.description ?
                                                                <div style={{ flex: 1, flexGrow: 1, textAlign: 'left', padding: '10px 0', width: 350, maxHeight: 300, wordBreak: 'break-word', overflowWrap: 'break-word', overflow: 'hidden', whiteSpace: 'pre-wrap' }}>
                                                                    {notification.description}
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </MenuItem>
                                                <IconButton
                                                    onClick={() => this.removeClicked(notification.id)}
                                                    color="secondary"
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </div>
                                    )
                                }
                            </ScrollContainer>,

                            <hr key="hr" style={{ marginTop: 4, marginBottom: 4 }} />,

                            <MenuItem
                                key="clearAll"
                                onClick={this.clearClicked}
                                className={clearAll}
                            >
                                Clear All
                            </MenuItem>
                        ]
                        :
                        <div style={{ textAlign: 'center' }}>
                            <Empty title="No Notifications..." subtitle="Go get yourself some coffee" />
                        </div>
                }
            </MenuList>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        notifications: state.notifications
    };
}

export default withStyles(headerLinksStyle)(connect(mapStateToProps)(NotificationsList));
